import React, { useState } from 'react'
import  {Drawer, List, ListItemButton, ListItemText, IconButton } from '@mui/material';
import { ListItemIcon } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { NavLink } from 'react-router-dom';


const DrawerComp = (props) => {
    const [openDrawer, setOpenDrawer ] = useState(false)
    const pages=props.pages

  return (
    <React.Fragment>
        <Drawer open= {openDrawer} onClose={ ()=> setOpenDrawer(false)}>
            <List>
                {pages.map((page, index)=>(
                   <ListItemButton onClick={ ()=> setOpenDrawer(false)} key={index}>
                        <ListItemIcon>
                            <ListItemText><NavLink to={page.path}>{page.text}</NavLink></ListItemText>
                        </ListItemIcon>
                    </ListItemButton> 
                ))} 
            </List>
        </Drawer>
        <IconButton sx={{color:'black', marginLeft: 'auto'}} onClick={ ()=> setOpenDrawer(!openDrawer)}>
            <MenuIcon />
        </IconButton>
    </React.Fragment>
  )
}

export default DrawerComp